import { createContext } from 'react';
import { IModifierPositionItem, IUpdateModifierPositions } from 'types';

export type TChangeModifierPositionSelectedItem = Nullable<string>;
export type TTypeOfChangeModifierPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface IChangeModifierPositionState {
	IDSelectedCustomer: TChangeModifierPositionSelectedItem;
	IDSelectedRestaurant: TChangeModifierPositionSelectedItem;
	IDSelectedModifierGroup: TChangeModifierPositionSelectedItem;
	positionsData: IModifierPositionItem[];
	dataForSubmit: IUpdateModifierPositions | null;
	typeOfModalWindow: TTypeOfChangeModifierPositionModalWindow;
}

export const changeModifierPositionInitialState: IChangeModifierPositionState = {
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedModifierGroup: null,
	positionsData: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IChangeModifierPositionContext extends IChangeModifierPositionState {
	setIDCustomer(value: TChangeModifierPositionSelectedItem): void;
	setIDRestaurant(value: TChangeModifierPositionSelectedItem): void;
	setIDModifierGroup(value: TChangeModifierPositionSelectedItem): void;
	resetSelectedControls(): void;
	setPositionsData(data: IModifierPositionItem[]): void;
	reorderItems(value: IModifierPositionItem[]): void;
	setDataForSubmit(value: IUpdateModifierPositions | null): void;
	changeTypeOfModalWindow(value: TTypeOfChangeModifierPositionModalWindow): void;
}

export const ChangeModifierPositionContext = createContext<IChangeModifierPositionContext>({
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDModifierGroup: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...changeModifierPositionInitialState,
});
